

export const Action_GetDMGroupCategories = "Action_GetDMGroupCategories";
export const Action_GetDMGroupCategoriesSuccess = "Action_GetDMGroupCategoriesSuccess";

export const Action_DeleteDMGroupCategories = "Action_DeleteDMGroupCategories";
export const Action_DeleteDMGroupCategoriesSuccess = "Action_DeleteDMGroupCategoriesSuccess";
export const Action_DeleteDMGroupCategoriesFailed = "Action_DeleteDMGroupCategoriesFailed";

export const Action_SaveDMGroupCategories = "Action_SaveDMGroupCategories";
export const Action_SaveDMGroupCategoriesSuccess = "Action_SaveDMGroupCategoriesSuccess";
export const Action_SaveDMGroupCategoriesFailed = "Action_SaveDMGroupCategoriesFailed";

export const Action_SaveThietLapGiaNhom = "Action_SaveThietLapGiaNhom";
export const Action_SaveThietLapGiaNhomSuccess = "Action_SaveThietLapGiaNhomSuccess";
export const Action_SaveThietLapGiaNhomFailed = "Action_SaveThietLapGiaNhomFailed";